/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
  '/customers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: {
          pageIndex?: number;
          itemsPerPage?: number;
          searchQuery?: string;
          txCenters?: string;
          priorityCustomerIds?: string;
          roles?: string;
          userIds?: string;
          isPrimary?: boolean;
          enabled?: boolean;
          isVerified?: boolean;
          orderBy?: components['schemas']['CustomerOrderByOptions'];
          asc?: boolean;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CustomerResponseListOperationResult'];
            'application/json': components['schemas']['CustomerResponseListOperationResult'];
            'text/json': components['schemas']['CustomerResponseListOperationResult'];
          };
        };
      };
    };
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateCustomerRequest'];
          'text/json': components['schemas']['CreateCustomerRequest'];
          'application/*+json': components['schemas']['CreateCustomerRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationSagaStateModelOperationResult'];
            'application/json': components['schemas']['OperationSagaStateModelOperationResult'];
            'text/json': components['schemas']['OperationSagaStateModelOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/customers/{customerId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          customerId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CustomerResponseOperationResult'];
            'application/json': components['schemas']['CustomerResponseOperationResult'];
            'text/json': components['schemas']['CustomerResponseOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          customerId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['OperationResult'];
            'application/json': components['schemas']['OperationResult'];
            'text/json': components['schemas']['OperationResult'];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          customerId: string;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['PatchCustomerRequest'];
          'text/json': components['schemas']['PatchCustomerRequest'];
          'application/*+json': components['schemas']['PatchCustomerRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CustomerResponseOperationResult'];
            'application/json': components['schemas']['CustomerResponseOperationResult'];
            'text/json': components['schemas']['CustomerResponseOperationResult'];
          };
        };
      };
    };
    trace?: never;
  };
  '/customers/userid/{userId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          userId: string;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['CustomerResponseOperationResult'];
            'application/json': components['schemas']['CustomerResponseOperationResult'];
            'text/json': components['schemas']['CustomerResponseOperationResult'];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/logos/files/signed-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          'application/json': components['schemas']['CreateSignedUrlRequest'];
          'text/json': components['schemas']['CreateSignedUrlRequest'];
          'application/*+json': components['schemas']['CreateSignedUrlRequest'];
        };
      };
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            'text/plain': components['schemas']['SignedUrlResponseOperationResult'];
            'application/json': components['schemas']['SignedUrlResponseOperationResult'];
            'text/json': components['schemas']['SignedUrlResponseOperationResult'];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
};
export type webhooks = Record<string, never>;
export type components = {
  schemas: {
    CreateCustomerRequest: {
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      photoPath: string | null;
      primaryPhone: string | null;
      secondaryPhone: string | null;
      /** Format: uuid */
      txCenterId: string;
      roles: string[] | null;
    };
    CreateSignedUrlRequest: {
      fileName: string | null;
      /** Format: int32 */
      fileContentLength: number | null;
      fileExtension: string | null;
    };
    /** @enum {string} */
    CustomerOrderByOptions: CustomerOrderByOptions;
    CustomerResponse: {
      /** Format: uuid */
      id: string;
      /** Format: uuid */
      userId: string | null;
      /** Format: uuid */
      txCenterId: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      photoPath: string | null;
      primaryPhone: string | null;
      secondaryPhone: string | null;
      isPrimary: boolean;
      roles: string[] | null;
      status: components['schemas']['CustomerStatus'];
      enabled: boolean;
      /** Format: date-time */
      invitedAt: string | null;
      isAcceptedToReceiveNotifications: boolean | null;
      isAcceptedTermsOfServiceAndPrivacyPolicy: boolean | null;
    };
    CustomerResponseListOperationResult: {
      error: components['schemas']['Error'];
      data: components['schemas']['CustomerResponsePaginatedData'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      readonly hasData: boolean;
    };
    CustomerResponseOperationResult: {
      error: components['schemas']['Error'];
      data: components['schemas']['CustomerResponse'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      readonly hasData: boolean;
    };
    CustomerResponsePaginatedData: {
      items: components['schemas']['CustomerResponse'][] | null;
      /** Format: int32 */
      pageIndex: number;
      /** Format: int32 */
      itemsPerPage: number;
      /** Format: int32 */
      totalItems: number;
      /** Format: int32 */
      readonly totalPages: number;
      /** Format: int32 */
      readonly currentItemCount: number;
    };
    /** @enum {string} */
    CustomerStatus: CustomerStatus;
    Error: {
      code: string | null;
      message: string | null;
      detailedCodes: string[] | null;
    };
    OperationResult: {
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      error: components['schemas']['Error'];
    };
    OperationSagaStateModel: {
      /** Format: uuid */
      correlationId: string;
    };
    OperationSagaStateModelOperationResult: {
      error: components['schemas']['Error'];
      data: components['schemas']['OperationSagaStateModel'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      readonly hasData: boolean;
    };
    PatchCustomerRequest: {
      /** Format: uuid */
      txCenterId: string | null;
      firstName: string | null;
      lastName: string | null;
      email: string | null;
      photoPath: string | null;
      primaryPhone: string | null;
      secondaryPhone: string | null;
      enabled: boolean | null;
      roles: string[] | null;
      isPrimary: boolean | null;
    };
    SignedUrlResponse: {
      signedUrl: string | null;
      fileName: string | null;
    };
    SignedUrlResponseOperationResult: {
      error: components['schemas']['Error'];
      data: components['schemas']['SignedUrlResponse'];
      readonly hasError: boolean;
      readonly hasNotError: boolean;
      readonly hasData: boolean;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
};
export type $defs = Record<string, never>;
export enum CustomerOrderByOptions {
  ContactName = 'ContactName',
  Email = 'Email',
  InvitedAt = 'InvitedAt',
}
export enum CustomerStatus {
  Initialized = 'Initialized',
  InviteSent = 'InviteSent',
  Verified = 'Verified',
}
export type operations = Record<string, never>;
